import { i18n } from "@lib/i18n";
import { clearLogin } from "@lib/utils/clearLogin";
import { rootRoute } from "@routes";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export const signInRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: `signin`,
    component: lazyRouteComponent(() => import("./SignIn")),
    beforeLoad: () => {
        clearLogin();
        return { getTitle: () => i18n.sign_in_title() };
    },
});
